import { apiRequest } from "./client"

export interface Grupa { id: number; naziv: string; poslovnaJedinicaId: number }
export interface Podgrupa { id: number; grupaId: number; naziv: string; parentPodgrupaId?: number }
export interface Artikal {
  id: number
  artikalId?: number
  sifra: string
  barkod?: string
  nazivArtikla: string
  jedMj: string
  poreznaStopa: number
  cijena: number
  fiskSifra: number
  podgrupaId?: number
  monitor?: number
  sankAktivan?: boolean
  sankTip?: string
  sankFaktor?: number
  imaSliku: boolean
  skladisnaKolicina?: number
  tipArtiklaId?: number
}
export interface CatalogResponse { grupe: Grupa[]; podgrupe: Podgrupa[]; artikli: Artikal[] }
export interface Printer { id: number; brojKase?: number; naziv: string; aktivna: boolean; noviConfig: boolean }

export async function getCatalog(token: string, deviceUuid: string): Promise<CatalogResponse> {
  return apiRequest("/catalog", { token, deviceUuid })
}

export async function getPrinters(token: string, deviceUuid: string): Promise<Printer[]> {
  return apiRequest("/catalog/printers", { token, deviceUuid })
}
